(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-get-wager-draw.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-get-wager-draw.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;
const tipsenApi = svs.components.tipsen.store.tipsenApi;
const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
const _svs$components$sport = svs.components.sport.drawsRedux,
  useDraw = _svs$components$sport.hooks.useDraw,
  selectDrawsRequests = _svs$components$sport.selectors.selectDrawsRequests,
  FetchState = _svs$components$sport.FetchState;
const useDefinition = svs.components.tipsen.engine.utils.useDefinition;
const _React2 = React,
  useMemo = _React2.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const DrawState = svs.components.sport.tipsenShared.DrawState;
const useGetDrawFromQueryString = () => {
  const _useLocation = useLocation(),
    search = _useLocation.search;
  const qs = new URLSearchParams(search);
  const draw = parseInt(qs.get('draw'), 10);
  const currentDraw = parseInt(qs.get('currentDraw'), 10);
  return useMemo(() => {
    const drawNumbers = [];
    if (draw) {
      drawNumbers.push(draw);
    }
    if (currentDraw) {
      drawNumbers.push(currentDraw);
    }
    return drawNumbers;
  }, [draw, currentDraw]);
};
const defaultReturn = [];
const useGetWagerDraw = _ref => {
  var _wager$productBet;
  let wagerId = _ref.wagerId;
  const _tipsenApi$useGetPlay = tipsenApi.useGetPlayerWagerQuery({
      wagerId
    }, {
      skip: !wagerId
    }),
    wager = _tipsenApi$useGetPlay.data;
  const _ref2 = (_wager$productBet = wager === null || wager === void 0 ? void 0 : wager.productBet) !== null && _wager$productBet !== void 0 ? _wager$productBet : {},
    drawNumber = _ref2.drawNumber,
    completedDrawNumbers = _ref2.completedDrawNumbers,
    lastCompletedDrawNumber = _ref2.lastCompletedDrawNumber,
    totalDrawCount = _ref2.totalDrawCount,
    productId = _ref2.productId;
  const hasMultiDraws = totalDrawCount > 1;
  const qsDrawNumbers = useGetDrawFromQueryString();
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    activeDrawNumber = _useState2[0],
    setActiveDrawNumber = _useState2[1];
  const definition = useDefinition();
  const shouldFetchJackpot = (definition === null || definition === void 0 ? void 0 : definition.hasJackpot) || false;
  const draw = useDraw({
    productId,
    drawNumber: activeDrawNumber
  }, {
    shouldFetchJackpot
  });
  const drawRequests = useSelector(selectDrawsRequests);
  const drawId = "".concat(productId, "_").concat(activeDrawNumber);
  const drawNumbersArray = useMemo(() => {
    if (completedDrawNumbers) {
      return completedDrawNumbers.slice().concat(drawNumber).concat(lastCompletedDrawNumber ? lastCompletedDrawNumber : []).sort((a, b) => a - b);
    }
    return defaultReturn;
  }, [completedDrawNumbers, lastCompletedDrawNumber, drawNumber]);
  const isAllRoundsCompleted = wager ? wager.productBet.completedDrawCount === wager.productBet.totalDrawCount : false;
  const validatedDrawNumbersArray = useMemo(() => {
    if (!hasMultiDraws) {
      return drawNumbersArray;
    }
    const _qsDrawNumbers = _slicedToArray(qsDrawNumbers, 1),
      selectedDrawNumber = _qsDrawNumbers[0];
    const _drawNumbersArray = _slicedToArray(drawNumbersArray, 1),
      firstDrawNumber = _drawNumbersArray[0];
    const drawOutsideCompletedDrawNumbers = isAllRoundsCompleted && !drawNumbersArray.includes(selectedDrawNumber);
    if (qsDrawNumbers.length > 0 && selectedDrawNumber >= firstDrawNumber && !drawOutsideCompletedDrawNumbers && drawNumbersArray.length) {
      return [...drawNumbersArray, ...qsDrawNumbers];
    }
    return drawNumbersArray;
  }, [drawNumbersArray, qsDrawNumbers, isAllRoundsCompleted, hasMultiDraws]);
  const _qsDrawNumbers2 = _slicedToArray(qsDrawNumbers, 1),
    selectedDrawNumber = _qsDrawNumbers2[0];
  const isSelectedDrawNumberValid = validatedDrawNumbersArray.length > drawNumbersArray.length;
  const lastValidatedDrawNumber = selectedDrawNumber || validatedDrawNumbersArray.slice().pop();
  const lastCompletedDrawNumberFromDraws = drawNumbersArray.slice().pop();
  const _drawNumbersArray2 = _slicedToArray(drawNumbersArray, 1),
    firstDrawNumber = _drawNumbersArray2[0];
  const isWagerLoaded = Boolean(wager);
  useEffect(() => {
    if (isSelectedDrawNumberValid && lastValidatedDrawNumber && selectedDrawNumber) {
      setActiveDrawNumber(selectedDrawNumber);
      return;
    }
    if (firstDrawNumber) {
      setActiveDrawNumber(firstDrawNumber);
    }
  }, [lastValidatedDrawNumber, isSelectedDrawNumberValid, firstDrawNumber, selectedDrawNumber]);
  const drawLoadingState = drawRequests[drawId];
  return useMemo(() => {
    var _ref3;
    const allDrawNumbers = new Set(validatedDrawNumbersArray);
    const activeDrawNumberIndex = (_ref3 = [...allDrawNumbers]) === null || _ref3 === void 0 ? void 0 : _ref3.findIndex(drawNumber => drawNumber === activeDrawNumber);
    if (hasMultiDraws && drawLoadingState && drawLoadingState !== FetchState.Pending) {
      if ((draw === null || draw === void 0 ? void 0 : draw.drawStateId) < DrawState.Opened) {
        setActiveDrawNumber(lastCompletedDrawNumberFromDraws);
      } else if (drawLoadingState === FetchState.Rejected && isWagerLoaded && qsDrawNumbers[0] > lastCompletedDrawNumberFromDraws + 1) {
        allDrawNumbers.delete(qsDrawNumbers[0]);
      } else if (drawLoadingState === FetchState.Rejected && isWagerLoaded) {
        allDrawNumbers.delete(lastCompletedDrawNumberFromDraws + 1);
      }
    }
    return {
      activeDrawNumber,
      allDrawNumbers,
      draw,
      activeDrawNumberIndex
    };
  }, [activeDrawNumber, draw, validatedDrawNumbersArray, drawLoadingState, hasMultiDraws, isWagerLoaded, lastCompletedDrawNumberFromDraws, qsDrawNumbers]);
};
setGlobal('svs.components.tipsen.hooksWager.useGetWagerDraw', useGetWagerDraw);

 })(window);